import type { AptiRequestConfig } from "@/lib/types/api";
import { getGroupAuthType } from "@/redux/actions/auth";
import type {
  GetPresignedUrlForGetPayload,
  GetPresignedUrlForGetResponse,
  GetPresignedUrlForPostPayload,
  GetPresignedUrlForPostResponse,
} from "@/core/types";
import { GROUP_AUTH_HEADER_NAME } from "@/constants/axios";

import { httpAuth } from "../utils/axios";

export const sharedRequestsTyped = {
  get_presigned_url: function ({
    data,
    version = "v4",
  }: {
    data: GetPresignedUrlForGetPayload;
    version?: string;
  }): Promise<GetPresignedUrlForGetResponse> {
    const config = {
      data,
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params: { showLoader: false },
      url: `/${version}/provider/get_presigned_url`,
    } satisfies AptiRequestConfig<GetPresignedUrlForGetPayload>;

    return httpAuth(config) as unknown as Promise<GetPresignedUrlForGetResponse>;
  },

  post_presigned_url: function ({
    data,
    version = "v4",
  }: {
    data: GetPresignedUrlForPostPayload;
    version?: string;
  }): Promise<GetPresignedUrlForPostResponse> {
    const config = {
      data,
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
      method: "POST",
      params: { showLoader: false },
      url: `/${version}/provider/get_presigned_url`,
    } satisfies AptiRequestConfig<GetPresignedUrlForPostPayload>;

    return httpAuth(config) as unknown as Promise<GetPresignedUrlForPostResponse>;
  },
};
